export default "/assets/images/awards-img-03-lg.svg?476ae4de97cbb39db813a4e1bb36fc41";